import classNames from 'classnames';
import { LucideIcon } from 'lucide-react';
import React from 'react';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg';

export type IconVariant = 'solid' | 'light';

const SIZE_PX: Record<IconSize, number> = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
};

const STROKE_WIDTH: Record<IconVariant, number> = {
  solid: 2,
  light: 1.5,
};

type Props = {
  icon: LucideIcon;
  size?: IconSize;
  variant?: IconVariant;
  className?: string;
};

/**
 * Shared Lucide icon wrapper (replaces Font Awesome `FontAwesomeIcon`).
 * Use `.app-icon` in global styles for spacing / cursor.
 */
const Icon: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    icon: LucideComponent,
    size = 'md',
    variant = 'solid',
    className,
  } = props;

  return (
    <span className={classNames('app-icon', className)}>
      <LucideComponent
        size={SIZE_PX[size]}
        strokeWidth={STROKE_WIDTH[variant]}
        aria-hidden
      />
    </span>
  );
};

export default Icon;
